/**
 * Builds menu data for the everfi_admin_navigation slug.
 * Used by fi-live admin HeaderMenu.
 *
 * @param {object} admin - current_admin user object (id, first_name, last_name)
 * @param {string} adminifiDomain - base adminifi URL (e.g. https://adminifi.everfi.com)
 * @param {string} logoutPath - admin_destroy_session_path (GET alias route defined in config/routes.rb)
 */
export const buildEverfiAdminNavigationMenu = ({ admin, adminifiDomain, logoutPath }) => {
  const userName = admin ? `${admin.first_name || ''} ${admin.last_name || ''}`.trim() : '';

  return {
    slug: 'everfi_admin_navigation',
    submenu_items: [
      {
        icon: 'circle-question',
        font_family: '',
        css_class: '',
        title: 'Help',
        target_url: 'https://fitkb.everfi.com/',
        target_method: '',
        new_window: true,
        slug: 'help',
      },
      {
        icon: 'circle-user',
        font_family: '',
        css_class: 'account',
        title: userName,
        target_url: '',
        target_method: '',
        new_window: false,
        slug: 'account',
        submenu_items: [
          {
            title: 'Logout',
            icon: '',
            font_family: '',
            css_class: '',
            target_url: logoutPath || `${adminifiDomain}/admin/session`,
            target_method: 'GET',
            new_window: false,
            slug: 'logout',
          },
        ],
      },
    ],
  };
};
